import { createSlice } from "@reduxjs/toolkit";

const branchSlice = createSlice({
    name:"branches",
    initialState:{
        branches:null
    },
    reducers:{
        setBranchList(state,action){
            state.branches = action?.payload;
        },
    }
})


export const {setBranchList} = branchSlice.actions
export default branchSlice.reducer